<div *ngFor="let route of routes">
  <div class="mx-auto" *ngIf="route.id.toLowerCase() == detailed_route.id.toLowerCase()">
    <span class="badge">Schedule</span>
    <div class="route-label">
      <div class="route-name">
        <h2> {{ route.name }} </h2>
      </div>
      <div class="route-details mb-2">
        <strong>
          <div class=""> {{ route.description }} </div>
        </strong>
      </div>
    </div>
  </div>
</div>